import { Navigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { API } from '@/App';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // First check if we have a token in localStorage
        const token = localStorage.getItem('session_token');
        
        if (!token) {
          console.log('No session token found');
          setIsAuthenticated(false);
          return;
        }

        // Validate token with backend
        const response = await fetch(`${API}/auth/me`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        
        if (!response.ok) {
          console.log('Session validation failed:', response.status);
          // Only remove token if it's actually invalid (401), not on network errors
          if (response.status === 401) {
            localStorage.removeItem('session_token');
          }
          setIsAuthenticated(false);
          return;
        }
        
        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Auth check failed:', error);
        // Don't remove token on network errors - user might just have connectivity issues
        // Check if token exists to determine auth state
        const token = localStorage.getItem('session_token');
        if (token) {
          // Assume authenticated if we have a token but can't verify (offline scenario)
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      }
    };

    checkAuth();
  }, [location.pathname]); // Re-check on route change, not just location.state

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center">
        <div className="text-gold-400 text-lg">Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
